<template>
  <iRow width="hug">
    <iTextEditInput
      v-model="localLastName"
      label="Last Name"
      :min-width="400"
      :disabled="editMode"
      editable-on-click
      @submit="submit"
    />
  </iRow>
</template>

<script>
// `~/stores/user-store` lives outside the editor directory tree.
import { UserSettingsPageElementMixin } from "%/dynamic-component-editor/standard-pages/user-settings-page/user-settings-page-element-mixin";

export default {
  name: "ChangeLastName",
  mixins: [UserSettingsPageElementMixin],
  elementPanelSettings: {
    displayName: "Change Last Name Field",
    displayIcon: "document",
    elementGroup: "userSettingsElements",
    elementType: "element",
  },
  data() {
    return {
      localLastName: "Last",
    };
  },
  methods: {
    submit() {
      // No-op in Studio canvas preview.
    },
  },
};
</script>
